import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  object-fit: contain;
  border-radius: ${pxToRem('36px')};
  -webkit-backdrop-filter: blur(${pxToRem('22px')});
  backdrop-filter: blur(${pxToRem('22px')});
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: rgba(255, 255, 255, 0.8);
  padding: ${pxToRem('8px')};
  margin: ${pxToRem('0px')} ${pxToRem('15px')};
`;

export const Box = styled.div`
  padding: ${pxToRem('12px')} ${pxToRem('58px')};
  flex-grow: 1;
  text-align: center;
  margin: ${pxToRem('5px')} ${pxToRem('10px')};

  :hover {
    cursor: pointer;
  }

  ${props =>
    props.highlight &&
    css`
      border-radius: ${pxToRem('28px')};
      background-color: ${props.theme.colors.blue.five};
    `}
`;
export const BoxContainer = styled.div`
  text-align: center;
`;

export const Divider = styled.div`
  height: ${pxToRem('1px')};
  background-color: ${props => props.theme.colors.lightGray2};
`;

export const AddContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${pxToRem('20px')};
`;

export const ProceedButtonContainer = styled.div`
  margin: ${pxToRem('40px')} auto ${pxToRem('20px')} auto;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const UploaderTitle = styled.div`
  text-align: center;
  padding-bottom: ${pxToRem('10px')};
  margin: ${pxToRem('24px')} auto;
`;

export const UploaderLink = styled.div`
  text-align: center;
  margin: 0 ${pxToRem('25px')};
`;

export const LinkWrapper = styled.div`
  font-family: OpenSans;
  font-size: ${pxToRem('16px')};
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #467afb;
  text-decoration: underline;
  cursor: pointer;
`;
